module.exports = __webpack_public_path__ + "img/web-triton-computer.c1d30ca8.jpg";